// extracted by mini-css-extract-plugin
module.exports = {"deliveriesReturns":"DeliveriesReturns_deliveriesReturns__Jrnx1","title":"DeliveriesReturns_title__ddd3J","text":"DeliveriesReturns_text__de0__"};